/**
 * Значок вкладки нижнего меню.
 *
 * Фигуры разные у каждой вкладки, а не две на четыре: в макете отличались
 * только скруглением, и на глаз это читалось как «два кружка и два
 * квадрата» — то есть не различалось вовсе. Форма здесь отвечает за «что
 * это», а состояние — за «где я»: невыбранная вкладка нарисована контуром,
 * выбранная залита и окрашена лаймом самим меню.
 *
 * Значение у фигур ровно такое, какое им можно дать честно: круг — аватар
 * профиля, квадрат — витрина, треугольник — просьба, ромб — сделка, где
 * две стороны сходятся. Читать их всё равно будут по подписи снизу;
 * фигура нужна, чтобы палец находил вкладку, не читая.
 */
export type NavShape = 'square' | 'triangle' | 'diamond' | 'circle';

export function NavMark({ shape, active }: { shape: NavShape; active: boolean }) {
  const paint = {
    fill: active ? 'currentColor' : 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinejoin: 'round' as const,
  };

  return (
    <svg width={18} height={18} viewBox="0 0 18 18" aria-hidden="true" focusable="false">
      {/* Фигуры занимают всю рамку: отступ ровно в половину обводки, иначе
          значок выходит мельче прежнего и меню на глаз тускнеет. */}
      {shape === 'square' && <rect x={1} y={1} width={16} height={16} rx={3} {...paint} />}
      {/* Треугольник при равной рамке выглядит мельче остальных — поэтому
          он шире и ниже, чем «по сетке». */}
      {shape === 'triangle' && <path d="M9 1.3 L17 16.4 H1 Z" {...paint} />}
      {shape === 'diamond' && <path d="M9 1 L17 9 L9 17 L1 9 Z" {...paint} />}
      {shape === 'circle' && <circle cx={9} cy={9} r={8} {...paint} />}
    </svg>
  );
}
